export default {
    label_task:{
        en:"Profile Settings",
        bn:'প্রোফাইল সেটিংস'
    },
    // label_new_task:{
    //     en:"New user",
    //     bn:'নতুন ব্যবহারকারী'
    // },
    // label_edit_task:{
    //     en:"Edit user",
    //     bn:'সম্পাদনা ব্যবহারকারী'
    // },
    // label_details_task:{
    //     en:"Details of user",
    //     bn:'ব্যবহারকারীর বিবরণ'
    // },
    label_qr_code:{
        en:"QR Code",
        bn:"QR কোড"
    },
    label_employee_id :{
        en:"Employee ID",
        bn:"কর্মচারী আইডি"
    },
    label_change_password:{
        en:"Change Password",
        bn:"পাসওয়ার্ড পরিবর্তন"
    },
    label_password_old :{
        en:"Old Password",
        bn:"পুরানো পাসওয়ার্ড"
    },
    label_password_new  :{
        en:"New Password",
        bn:"নতুন পাসওয়ার্ড"
    },
    label_profile_picture  :{
        en:"Profile Picture",
        bn:"প্রোফাইল ছবি"
    },
    label_user_type_name :{
        en:"User Type",
        bn:"ব্যবহারকারী ধরন"
    },
    label_title_authentication :{
        en:"Username,Password, Status",
        bn:"ইউজারনেম, পাসওয়ার্ড, স্ট্যাটাস"
    },
    label_title_identification :{
        en:"Personal Information",
        bn:"ব্যক্তিগত তথ্য"
    },
    label_max_logged_browser :{
        en:"Maximum Allowed Browser",
        bn:"সর্বাধিক অনুমোদিত ব্রাউজার"
    },
    label_mobile_authentication_off_end :{
        en:"Mobile authentication off",
        bn:"মোবাইল যাচাইকরণ বন্ধ"
    },
}